module.exports = __webpack_public_path__ + "static/media/Intro-AFTER-trial.e009f9a1.mp3";